import {
    OptimizerRuntimeError,
    type OptimizerRuntimeErrorShape,
} from '@analytical-alley/opt-wasm';

export const toInitError = (error: unknown): Error => {
    if (error instanceof OptimizerRuntimeError) {
        return new Error(`[${error.code}] ${error.message}`, { cause: error });
    }

    if (error instanceof Error) {
        return error;
    }

    const maybeShape = error as Partial<OptimizerRuntimeErrorShape>;
    if (
        maybeShape &&
        typeof maybeShape.code === 'string' &&
        typeof maybeShape.message === 'string'
    ) {
        return new Error(`[${maybeShape.code}] ${maybeShape.message}`, {
            cause: error as Error,
        });
    }

    return new Error('Failed to initialize optimizer runtime');
};
